import { GetServerSideProps, GetServerSidePropsContext, Page } from "next";
import { useTranslation } from "@finbackoffice/site-core";
import { PopupTags, TranslationScopes } from "@finbackoffice/enums";
import Seo from "components/base/seo/Seo";
import getLiveLayout from "components/layout/sportsbook/live/LiveLayout";
import {
    CommonSsrProps,
    clientBFFSingleton,
    createGetServerSideProps,
    getServerData,
    getServerRuntimeConfig,
} from "services/ssr";
import { getCurrentLocale } from "utils/helpers";
import LiveSports from "components/pages/sport/live/LiveSports";

export const getServerSideProps: GetServerSideProps = createGetServerSideProps<CommonSsrProps>(
    async (context: GetServerSidePropsContext) => {
        const runtimeConfig = await getServerRuntimeConfig();
        const client = clientBFFSingleton.getInstance(context.req.cookies.jwt);
        const locale = getCurrentLocale(runtimeConfig, context.locale);

        const { translations, configs, profile, popupBanners } = await getServerData(
            runtimeConfig,
            context,
            client,
            {
                translationScope: [TranslationScopes.Live],
                popupBanners: { scope: [PopupTags.Live], device: PopupTags.Mobile },
            },
        );

        return {
            props: {
                configs,
                runtimeConfig,
                jwt: context.req.cookies.jwt || "",
                profile: profile || null,
                locale,
                translations,
                popupBanners: popupBanners || [],
            },
        };
    },
);

const LiveTopLeaguesPage: Page = () => {
    const { t } = useTranslation();

    return (
        <>
            <Seo
                page={TranslationScopes.Live}
                replace={{
                    title: {
                        page_name: `${t("pageName_live")}`,
                    },
                }}
            />
            <LiveSports layout="tournaments" />
        </>
    );
};

LiveTopLeaguesPage.getLayout = getLiveLayout;

export default LiveTopLeaguesPage;
